import { memo } from 'react';
import { Text } from '@acv/clearcar-component-lib';
import WarningRoundedIcon from '@mui/icons-material/WarningRounded';
import Tooltip from './Tooltip';
import { useLocale } from '@portal/hooks';
import { styled } from './lib';

const SpamBadge = memo(({ size = 'sm', iconOnly = false }) => {
  const { locale } = useLocale();

  if (iconOnly) {
    return (
      <Tooltip title={locale.spamBadgeTooltip} bgColor="#333">
        <IconOnlyContainer data-testid="e2e-spam-icon">
          <WarningRoundedIcon
            sx={{
              fontSize: size === 'sm' ? 16 : 18,
              color: '#402D00 !important',
              marginRight: 0.5,
            }}
          />
        </IconOnlyContainer>
      </Tooltip>
    );
  }

  return (
    <Tooltip title={locale.spamBadgeTooltip} bgColor="#333">
      <BadgeContainer data-testid="e2e-spam-badge">
        <WarningRoundedIcon
          sx={{
            fontSize: size === 'sm' ? 16 : 18,
            color: '#402D00 !important',
          }}
        />
        <BadgeText size="s" data-testid="e2e-spam-badge-text">
          {locale.spamBadgeLabel}
        </BadgeText>
      </BadgeContainer>
    </Tooltip>
  );
});

SpamBadge.displayName = 'SpamBadge';

export default SpamBadge;

const BadgeContainer = styled('span')({
  display: 'inline-flex',
  alignItems: 'center',
  gap: '4px',
  padding: '5px 8px',
  borderRadius: '5px',
  backgroundColor: '#FFEFBF',
  cursor: 'pointer',
});

const IconOnlyContainer = styled('span')({
  display: 'inline-flex',
  alignItems: 'center',
  cursor: 'pointer',
});

const BadgeText = styled(Text)({
  color: '#402D00',
});
